import { Box, Typography } from "@mui/material";

const Field = ({ label, children, sx }) => (
  <Box sx={{ minWidth: 0, ...sx }}>
    <Typography
      sx={{ fontSize: 12, fontWeight: 500, color: "#667085", lineHeight: 1.4 }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        mt: 0.25,
        fontSize: 14,
        fontWeight: 600,
        color: "#101828",
        lineHeight: 1.4,
        fontVariantNumeric: "tabular-nums",
        wordBreak: "break-word",
      }}
    >
      {children}
    </Typography>
  </Box>
);

const StatusPill = ({ isOnline }) => {
  const color = isOnline ? "#1B7F43" : "#B42318";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        mt: 0.25,
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        border: "1px solid",
        borderColor: isOnline ? "#B7E4C7" : "#F5C2C2",
        bgcolor: isOnline ? "#EAF7EF" : "#FDECEC",
        color,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "currentColor",
          boxShadow: isOnline ? "0 0 0 4px rgba(27,127,67,.18)" : "none",
        }}
      />
      <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.4 }}>
        {isOnline ? "Online" : "Offline"}
      </Typography>
    </Box>
  );
};

const StationSyncStatus = ({
  syncTimestamp,
  stationIMEI,
  partnerId,
  isOnline,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        columnGap: 2,
        gridTemplateColumns: "1fr 1fr",
        gridTemplateAreas: '"imei status" "partner sync"',
        justifyContent: { md: "space-between" },
        alignItems: "start",
        p: { xs: 2, md: 2.5 },
        bgcolor: "#FFFFFF",
        border: "1px solid #E3E8EE",
        borderRadius: 3,
        boxShadow: "0 1px 2px rgba(16,24,40,.04)",
      }}
    >
      <Field label="Station IMEI" sx={{ gridArea: "imei" }}>
        {stationIMEI || "--"}
      </Field>
      <Field label="Partner ID" sx={{ gridArea: "partner" }}>
        {partnerId || "--"}
      </Field>
      <Box sx={{ gridArea: "status" }}>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 500,
            color: "#667085",
            lineHeight: 1.4,
          }}
        >
          Station status
        </Typography>
        <StatusPill isOnline={isOnline} />
      </Box>
      <Field label="Last sync" sx={{ gridArea: "sync" }}>
        {syncTimestamp || "--"}
      </Field>
    </Box>
  );
};

export default StationSyncStatus;
